import Api from "../../utils/axios";

const OrderApi = {
  getAllOrders: (payload,search="") => Api.post(`order/get-all-orders?search=${search}`,payload), 
  getOrderById: (id) => Api.get(`order/get-order-by-id/${id}`), 
  getAllFoodOrders: (payload,search="") => Api.post(`food-order/get-all-orders?search=${search}`,payload), 
  updateOrders: (payload) => Api.put(`order/update-order`,payload),  
  updateFoodOrders: (payload) => Api.put(`food-order/update-order`,payload),  
};

export default OrderApi;


export const reviewApi={
  getAllVendorReviews: (payload,search="") => Api.post(`order/get-all-vendor-review?search=${search}`,payload),  
  getAllProductReviews: (payload,search="") => Api.post(`order/get-all-product-review?search=${search}`,payload),  
  hideProductReview: (reviewId) => Api.post(`admin/hide-product-review/${reviewId}`),  
  hideVendorReview: (reviewId) => Api.post(`admin/hide-vendor-review/${reviewId}`),  
}